export default "__VITE_PUBLIC_ASSET__7e26d1fa__"